import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Link } from 'react-router-dom';

const Terms = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-20 sm:py-24">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">תנאי שימוש</h1>
          <p className="text-sm sm:text-base text-muted-foreground mb-6 sm:mb-8">
            עדכון אחרון: {new Date().toLocaleDateString('he-IL')}
          </p>

          <div className="prose prose-sm sm:prose-lg max-w-none mb-6 sm:mb-8">
            <p className="text-sm sm:text-base text-foreground leading-relaxed">
              ברוכים הבאים לאתר משרד עורכי דין סמירנוב צולר. השימוש באתר זה כפוף לתנאים המפורטים למטה.
              על ידי כניסה לאתר ושימוש בו, אתה מסכים לתנאי שימוש אלה במלואם.
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
            <AccordionItem value="item-1" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                1. תחולת התנאים
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground space-y-3 pb-4">
                <p>
                  תנאי שימוש אלה חלים על כל שימוש באתר, לרבות גלישה, קריאת תכנים, שימוש בטפסים,
                  ושימוש בעוזר המשפטי הווירטואלי.
                </p>
                <p>
                  אם אינך מסכים לתנאים אלה, אנא הימנע משימוש באתר.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                2. שימוש מותר באתר
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">אתה רשאי להשתמש באתר למטרות הבאות בלבד:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-1">
                  <li>קבלת מידע כללי על שירותי המשרד</li>
                  <li>יצירת קשר עם המשרד לצורך קבלת ייעוץ משפטי</li>
                  <li>שימוש בעוזר המשפטי הווירטואלי לקבלת מידע ראשוני</li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="border rounded-lg px-4 sm:px-6">
              <AccordionTrigger className="text-base sm:text-lg font-semibold hover:no-underline py-4">
                3. שימוש אסור
              </AccordionTrigger>
              <AccordionContent className="text-sm sm:text-base text-muted-foreground pb-4">
                <p className="mb-3">אסור לך לעשות כל אחת מהפעולות הבאות:</p>
                <ul className="list-disc pr-5 sm:pr-6 space-y-2">
                  <li>שימוש באתר למטרות בלתי חוקיות או בניגוד לתנאים אלה</li>
                  <li>פגיעה בתפקוד האתר או ניסיון לחדור למערכות המחשב</li>
                  <li>העתקה, שכפול או הפצה של תוכן מהאתר ללא רשות מפורשת</li>
                  <li>שימוש בכלים אוטומטיים (בוטים, סקריפטים) לגישה לאתר</li>
                  <li>שימוש לרעה בטפסי יצירת קשר או בעוזר הווירטואלי (ספאם, הטרדה)</li>
                  <li>העלאת תוכן זדוני, וירוסים או קוד מזיק</li>
                </ul>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                4. אין יחסי עורך דין-לקוח
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground space-y-3">
                <p className="font-semibold text-foreground">
                  חשוב להבין: גלישה באתר או שימוש בעוזר המשפטי הווירטואלי אינם יוצרים יחסי עורך דין-לקוח.
                </p>
                <p>
                  המידע באתר הוא למטרות הדרכה כלליות בלבד ואינו מהווה ייעוץ משפטי. כל מידע שתקבל
                  מהעוזר הווירטואלי אינו תחליף לייעוץ משפטי אישי ומקצועי.
                </p>
                <p>
                  יחסי עורך דין-לקוח נוצרים רק לאחר חתימה על הסכם התקשרות מפורש עם המשרד.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                5. דיוק המידע והעוזר הווירטואלי
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground space-y-3">
                <p>
                  אנו משתדלים לספק מידע מדויק ועדכני, אך איננו יכולים להבטיח שהמידע באתר או
                  התשובות של העוזר הווירטואלי נכונות, שלמות או עדכניות בכל עת.
                </p>
                <p>
                  העוזר המשפטי הווירטואלי פועל באמצעות בינה מלאכותית ועלול לספק תשובות שגויות,
                  חלקיות או לא רלוונטיות למצבך הספציפי.
                </p>
                <p className="font-semibold text-foreground">
                  אל תסתמך על המידע באתר לצורך קבלת החלטות משפטיות. פנה תמיד לייעוץ משפטי אישי.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                6. הגבלת אחריות
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground space-y-3">
                <p>
                  המשרד לא יהיה אחראי לכל נזק ישיר, עקיף, תוצאתי או מקרי הנובע מ:
                </p>
                <ul className="list-disc pr-6 space-y-1">
                  <li>שימוש או חוסר יכולת לעשות שימוש באתר</li>
                  <li>הסתמכות על מידע המופיע באתר או מהעוזר הווירטואלי</li>
                  <li>תקלות טכניות, הפסקות שירות או אבטחת מידע</li>
                  <li>גישה לא מורשית או שינוי של המידע שלך</li>
                </ul>
                <p className="mt-3">
                  השימוש באתר הוא על אחריותך הבלעדית.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                7. קניין רוחני
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground space-y-3">
                <p>
                  כל התוכן באתר, לרבות טקסטים, עיצוב, לוגו, תמונות, קוד וכל חומר אחר,
                  הם רכושו הבלעדי של משרד עורכי דין סמירנוב צולר או בעלי רישיונות אחרים.
                </p>
                <p>
                  אסור להעתיק, לשכפל, להפיץ, למכור או לעשות כל שימוש מסחרי בתוכן האתר
                  ללא אישור בכתב מראש מהמשרד.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                8. קישורים לאתרים חיצוניים
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                <p>
                  האתר עשוי לכלול קישורים לאתרים חיצוניים. אנו אינם אחראים לתוכן, למדיניות הפרטיות
                  או לפרקטיקות של אתרים אלה. הכללת קישור אינה מהווה המלצה או אישור.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-9" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                9. שינויים בתנאי השימוש
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                <p>
                  אנו שומרים לעצמנו את הזכות לשנות את תנאי השימוש בכל עת. שינויים ייכנסו לתוקף
                  מיד עם פרסומם באתר. המשך שימוש באתר לאחר שינוי מהווה הסכמה לתנאים המעודכנים.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-10" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                10. סמכות שיפוט ודין החל
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                <p className="mb-3">
                  תנאי שימוש אלה יפורשו וינוהלו על פי דיני מדינת ישראל.
                </p>
                <p>
                  סמכות השיפוט הבלעדית בכל מחלוקת הנובעת מתנאים אלה תהיה לבתי המשפט המוסמכים
                  בתל אביב-יפו, ישראל.
                </p>
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-11" className="border rounded-lg px-6">
              <AccordionTrigger className="text-lg font-semibold hover:no-underline">
                11. יצירת קשר
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                <p className="mb-3">
                  לשאלות או הבהרות בנוגע לתנאי שימוש אלה, ניתן ליצור איתנו קשר:
                </p>
                <div className="bg-muted/50 p-4 rounded-lg space-y-2">
                  <p>אימייל: <a href="mailto:office@szlaw.co.il" className="text-primary hover:underline">office@szlaw.co.il</a></p>
                  <p>טלפון: <a href="tel:+97231234567" className="text-primary hover:underline">03-123-4567</a></p>
                  <p>כתובת: רח' הבנים 14, תל אביב-יפו, ישראל</p>
                </div>
              </AccordionContent>
            </AccordionItem>
          </Accordion>

          <div className="mt-12 p-6 bg-muted/30 rounded-lg border">
            <h3 className="text-lg font-semibold mb-3">צריך עזרה משפטית?</h3>
            <p className="text-muted-foreground mb-4">
              אם יש לך שאלה משפטית או אתה זקוק לייעוץ מקצועי, אנו כאן כדי לעזור.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-md bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2"
            >
              צור קשר למתן ייעוץ
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;